import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Comment, UiComment } from '../../models/comment/comment.model';

@Component({
  selector: 'ptl-comment-list',
  templateUrl: './comment-list.component.html',
  styleUrls: ['./comment-list.component.scss'],
})
export class CommentListComponent {
  @Input() comments: UiComment[] = [];
  @Input() momentId!: number;
  @Input() currentUserId!: string;

  @Output() commentUpdated = new EventEmitter<Comment>();
  @Output() commentDeleted = new EventEmitter<string>();
  @Output() commentLiked = new EventEmitter<{ commentId: string; isLiked: boolean }>();
  @Output() replyCreated = new EventEmitter<{ reply: Comment; parentCommentId: string }>();

  onCommentUpdated(comment: Comment): void {
    this.commentUpdated.emit(comment);
  }

  onCommentDeleted(commentId: string): void {
    this.commentDeleted.emit(commentId);
  }

  onCommentLiked(commentId: string, isLiked: boolean): void {
    this.commentLiked.emit({ commentId, isLiked });
  }

  onReplyCreated(reply: Comment, parentCommentId: string): void {
    this.replyCreated.emit({ reply, parentCommentId });
  }

  trackByCommentId(index: number, comment: UiComment): string {
    return comment.id;
  }
}
